import { isSeries } from '@b/checkout/selectors/event';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class TicketPickerCardHeader extends Component {
    render() {
        return(
            <div className="tickets__list">
                <div className="ticket__header">
                    <div className="ticket-header__name" role='heading' aria-level={this.props.isSeries ? 4 : 3}>{this.props.header}</div>
                    <div className="ticket-header__price"></div>
                    <div className="ticket-header__quantity"></div>
                </div>
                {this.props.children}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isSeries: isSeries(state),
    };
};

export default connect(mapStateToProps)(TicketPickerCardHeader);
